export const initialMessageState = {
    messages: [],
};

export function messageReducer(state, action) {
    switch (action.type) {
        case 'replace': {
            const next = Array.isArray(action.messages) ? [...action.messages] : [];
            return { ...state, messages: next };
        }
        case 'append': {
            if (!action.message) {
                return state;
            }
            return { ...state, messages: [...state.messages, action.message] };
        }
        case 'appendMany': {
            if (!Array.isArray(action.messages) || action.messages.length === 0) {
                return state;
            }
            return { ...state, messages: [...state.messages, ...action.messages] };
        }
        case 'reset':
            return initialMessageState;
        default:
            return state;
    }
}

export function mapEventToMessage(event) {
    if (!event || typeof event !== 'object') {
        return null;
    }
    const message = typeof event.message === 'string' && event.message.trim().length > 0
        ? event.message.trim()
        : typeof event.payload?.message === 'string'
            ? event.payload.message
            : null;
    if (!message) {
        return null;
    }
    return {
        role: 'system',
        type: event.type || 'event',
        text: message,
        timestamp: event.timestamp,
        payload: event.payload ?? null,
    };
}
